export const DEFAULT_OVERLAY_OPTIONS = [
  { "id": "UNSPECIFIED", "value": "Unspecified", "label": "Unspecified" },
  { "id": "SOONERSALOONWHITE", "value": "SoonerSaloonWhite", "label": "SoonerSaloonWhite" },
  { "id": "SOONERSALOONTRANSPARENT", "value": "SoonerSaloonTransparent", "label": "SoonerSaloonTransparent" },
  { "id": "VIRGINIA", "value": "Virginia", "label": "Virginia" },
  { "id": "CLEVELANDPOLICEDISTRICT_1", "value": "ClevelandPoliceDistrict1", "label": "ClevelandPoliceDistrict1" },
  { "id": "CLEVELANDPOLICEDISTRICT_2", "value": "ClevelandPoliceDistrict2", "label": "ClevelandPoliceDistrict2" },
  { "id": "CLEVELANDPOLICEDISTRICT_3", "value": "ClevelandPoliceDistrict3", "label": "ClevelandPoliceDistrict3" },
  { "id": "CLEVELANDPOLICEDISTRICT_4", "value": "ClevelandPoliceDistrict4", "label": "ClevelandPoliceDistrict4" },
  { "id": "CLEVELANDPOLICEDISTRICT_5", "value": "ClevelandPoliceDistrict5", "label": "ClevelandPoliceDistrict5" },
  { "id": "CLEVELANDWARD_1", "value": "ClevelandWard1", "label": "ClevelandWard1" },
  { "id": "CLEVELANDWARD_2", "value": "ClevelandWard2", "label": "ClevelandWard2" },
  { "id": "CLEVELANDWARD_3", "value": "ClevelandWard3", "label": "ClevelandWard3" },
  { "id": "CLEVELANDWARD_4", "value": "ClevelandWard4", "label": "ClevelandWard4" },
  { "id": "CLEVELANDWARD_5", "value": "ClevelandWard5", "label": "ClevelandWard5" },
  { "id": "CLEVELANDWARD_6", "value": "ClevelandWard6", "label": "ClevelandWard6" },
  { "id": "CLEVELANDWARD_7", "value": "ClevelandWard7", "label": "ClevelandWard7" },
  { "id": "CLEVELANDWARD_8", "value": "ClevelandWard8", "label": "ClevelandWard8" },
  { "id": "CLEVELANDWARD_9", "value": "ClevelandWard9", "label": "ClevelandWard9" },
  { "id": "CLEVELANDWARD_10", "value": "ClevelandWard10", "label": "ClevelandWard10" },
  { "id": "CLEVELANDWARD_11", "value": "ClevelandWard11", "label": "ClevelandWard11" },
  { "id": "CLEVELANDWARD_12", "value": "ClevelandWard12", "label": "ClevelandWard12" },
  { "id": "CLEVELANDWARD_13", "value": "ClevelandWard13", "label": "ClevelandWard13" },
  { "id": "CLEVELANDWARD_14", "value": "ClevelandWard14", "label": "ClevelandWard14" },
  { "id": "CLEVELANDWARD_15", "value": "ClevelandWard15", "label": "ClevelandWard15" },
  { "id": "CLEVELANDWARD_16", "value": "ClevelandWard16", "label": "ClevelandWard16" },
  { "id": "CLEVELANDWARD_17", "value": "ClevelandWard17", "label": "ClevelandWard17" },
  { "id": "CLEVELANDWARD_18", "value": "ClevelandWard18", "label": "ClevelandWard18" },
  { "id": "CLEVELANDWARD_19", "value": "ClevelandWard19", "label": "ClevelandWard19" }
]

export const USER_STATE_OPTIONS = [
  { "id": "LOCKED", "value": "Locked", "label": "Locked" },
  { "id": "UNLOCKED", "value": "Unlocked", "label": "Unlocked" }
]

export const FIRST_LOGIN_PAGE_OPTIONS = [
  // { "id": "MAIN_MENU", "value": "menu.top", "label": "Main Menu" },
  // { "id": "DEVICE_MAP", "value": "map.device", "label": "Device Map" },
  { "id": "DASHBOARD", "value": "menu.dashDetail", "label": "Dashboard" },
  { "id": "FLEET_MAP", "value": "map.fleet", "label": "Map Overview - Fleet Map" },
  { "id": "DETAIL_REPORTS", "value": "menu.rpt.devDetail", "label": "Reports" },
  // { "id": "FLEET_REPORTS", "value": "menu.rpt.grpSummary", "label": "Fleet Reports" }
]

export const MAP_TYPE_OPTIONS = [
  { value: '0', label: 'Street View' },
  { value: '1', label: 'Satellite View' },
];